import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
  
import useDeductibleScheduleSteps from "./hooks/useDeductibleScheduleSteps";  
  
const DeductibleScheduleSteps = () => {  
  const deductibleScheduleStepsData = useDeductibleScheduleSteps();  
  
  return (  
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={deductibleScheduleStepsData.leftButtons} align="left" />    
      <div className="header-section">  
        <h1>  
          {deductibleScheduleStepsData.screen_title} -{" "}  
          <span className="heading-cod">{deductibleScheduleStepsData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={deductibleScheduleStepsData.formFields}  
        dropdownValues={deductibleScheduleStepsData.dropdownValues}  
        paramsData={deductibleScheduleStepsData.paramsData}  
        updataParamData={deductibleScheduleStepsData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={deductibleScheduleStepsData.ctaButtons} />  
      <DisplayTable  
        data={deductibleScheduleStepsData.data}  
        parmKey={deductibleScheduleStepsData.parmKey2}  
        menuOptions={deductibleScheduleStepsData.menuOptions}  
        tableHeaders={deductibleScheduleStepsData.columnDef}  
        setRowData={deductibleScheduleStepsData.setRowData}  
        selectedPriceSchedules={deductibleScheduleStepsData.selectedRows}  
        setSelectedPriceSchedules={deductibleScheduleStepsData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={deductibleScheduleStepsData.first}  
          rows={deductibleScheduleStepsData.rows}  
          totalRecords={deductibleScheduleStepsData.totalRecords}  
          currentPage={deductibleScheduleStepsData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={deductibleScheduleStepsData.onPageChange}  
        />  
      </div>  
      {deductibleScheduleStepsData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={deductibleScheduleStepsData.isConfirmationModalOpen}  
          onRequestClose={deductibleScheduleStepsData.closeConfirmationModal}  
          onBack={deductibleScheduleStepsData.closeConfirmationModal}  
          onSave={deductibleScheduleStepsData.deleteDeductibleSchedule}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={deductibleScheduleStepsData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default DeductibleScheduleSteps;  
